import { useEffect, useState } from "react";
import { api } from "./api";

let cache = null;
const subs = new Set();

export async function refreshBranding() {
  const { data } = await api.get("/public/branding");
  cache = data;
  subs.forEach((f) => f(data));
  return data;
}

export function useBranding() {
  const [b, setB] = useState(cache);
  useEffect(() => {
    subs.add(setB);
    if (!cache) refreshBranding().catch(() => {});
    return () => { subs.delete(setB); };
  }, []);
  return b;
}
